import React from 'react';

import { CloudInventory } from './index';

/** The flag-off page. It intentionally keeps the existing inventory APIs. */
export const LegacyCloudInventoryPage = () => (
  <CloudInventory useInventoryV3={false} />
);
